import axios, { AxiosError } from "axios";
// import MockAdapter from "axios-mock-adapter";
// const mock = new MockAdapter(axios);

export interface Product {
    product_id: string;
    quantity: number;
}

export interface ProductsRequest {
    product_type: "stove" | "heater"; //商品タイプ（stove: テーブルコンロ, heater: ガスファンヒーター）
}
export interface ProductsResponse {
    id: string; //商品ID
    standard_price: number | null; //標準価格（円）
    sales_price: number | null; //販売価格（円）
    discount_rate: number | null; //割引率（%）
    is_outlet: boolean | null; //アウトレット商品かどうか
    product_type: "stove" | "heater"; //商品タイプ（stove: テーブルコンロ, heater: ガスファンヒーター）
    is_recommended: boolean | null; //おすすめ商品かどうか
    is_active: boolean | null; //販売中かどうか
    is_low_stock: boolean | null; //在庫少かどうか
    is_limited: boolean | null; //限定商品かどうか
    name: string; //商品名
    comment: string | null; //商品コメント
    recommended_headline: string | null; //おすすめ商品のヘッドライン
    recommended_body: string | null; //おすすめ商品の説明文
    recommended_sort_order: number | null; //おすすめ商品の表示順序
    display_sort_order: number | null; //商品の表示順序
    eyecatch_image_url: string | null; //アイキャッチ画像URL
    manufacturer: string | null; //メーカー名
    model: string | null; //型番
    model_salesforce: string | null; //Salesforce用型番
    inventory: number; //在庫数
    color: string | null; //色
    size_width_mm: number | null; //幅（mm）
    size_height_mm: number | null; //高さ（mm）
    size_depth_mm: number | null; //奥行き（mm）
    weight_kg: string | null; //重量（kg）
    top_board_size: string | null; //天板サイズ
    top_plate: string | null; //天板材質
    grill_width_mm: number | null; //グリル幅（mm）
    grill_depth_mm: number | null; //グリル奥行き（mm）
    grill_height_mm: number | null; //グリル高さ（mm）
    power_source: string | null; //電源・ガス種
    output_kw: string | null; //出力（kW）
    heating_capacity: string | null; //暖房能力（ヒーター用） small medium large
    display_start_at: string | null; //表示開始日時
    display_end_at: string | null; //表示終了日時
    carousel_images: {
        id: number;
        image_url: string;
        sort_order: number;
    }[]; //カルーセル画像一覧
}

export interface SummaryRequest {
    product_type: "stove" | "heater"; //商品タイプ（stove: テーブルコンロ, heater: ガスファンヒーター）
}
export interface SummaryResponse {
    max_discount_rate: number | null; //最大割引率（%）
    has_outlet_products: boolean; //アウトレット商品があるかどうか
}

export interface OrdersRequest {
    products: Product[];
    payment_method: "PAYPAY_WAP" | "CREDITCARD_WAP";
    orderer_family_name: string;
    orderer_given_name: string;
    orderer_family_kana: string;
    orderer_given_kana: string;
    orderer_phone: string;
    orderer_postal_code: string;
    orderer_pref_code: string;
    orderer_city: string;
    orderer_address1: string;
    orderer_address2?: string;
    ship_family_name: string;
    ship_given_name: string;
    ship_family_kana: string;
    ship_given_kana: string;
    ship_phone: string;
    ship_postal_code: string;
    ship_pref_code: string;
    ship_city: string;
    ship_address1: string;
    ship_address2?: string;
    remarks?: string;
}

export interface OrderSuccessResponse {
    success: boolean;
    order_id: string;
    order_token: string;
    order_token_expire_at: string;
}

export interface OrderErrorResponse {
    success?: boolean;
    message: string;
    errors: Record<string, string[] | string>;
}
export type OrdersResponse = OrderSuccessResponse | OrderErrorResponse;

const hostname = window.location.hostname;
const API_AVAILABLE =
    hostname === "saibugas-tclp.makemistakes.dev" || hostname === "localhost"
        ? false
        : true;
const baseURL = window.location.origin;

export const getProducts = async (
    product_type: "stove" | "heater"
): Promise<ProductsResponse[] | null> => {
    if (API_AVAILABLE) {
        try {
            const response = (await axios.get(
                `${baseURL}/api/products?product_type=${product_type}`,
                {
                    withCredentials: false,
                    headers: {
                        Accept: "application/json",
                    },
                }
            )) as { data: ProductsResponse[] };
            const data = response.data;
            // console.log("getProductsResponse:", response);
            return data;
        } catch (error) {
            console.error("getProductsError:", error);
            return null;
        }
    } else {
        if (product_type === "stove") {
            const defaultData: ProductsResponse[] = [
                {
                    color: "プレミアムブラック",
                    comment: "最新技術を搭載したおすすめのテーブルコンロです。",
                    discount_rate: 27,
                    display_end_at: "2025-09-24T02:51:19.000000Z",
                    display_sort_order: 0,
                    display_start_at: "2025-08-24T02:51:19.000000Z",
                    eyecatch_image_url: "/assets/img/pr_tc/push_03.png",
                    grill_depth_mm: 380,
                    grill_height_mm: 100,
                    grill_width_mm: 320,
                    heating_capacity: "medium",
                    id: "0198df23-25d0-7337-8de5-0d31b53e18e6",
                    inventory: 10,
                    is_active: true,
                    is_limited: true,
                    is_low_stock: true,
                    is_outlet: true,
                    is_recommended: true,
                    manufacturer: "株式会社サイブガス",
                    model: "STOVE-RECOMMEND",
                    model_salesforce: "SF-STOVE-RECOMMEND",
                    name: "おすすめテーブルコンロ",
                    output_kw: "7.95",
                    power_source: "AC100V（50/60Hz）",
                    product_type: "stove",
                    recommended_body:
                        "安全性と使いやすさを両立した人気商品です。多くのお客様にご愛用いただいています。",
                    recommended_headline: "売れ筋No.1のテーブルコンロ",
                    recommended_sort_order: 2,
                    sales_price: 58676,
                    size_depth_mm: 485,
                    size_height_mm: 195,
                    size_width_mm: 620,
                    standard_price: 88388,
                    top_board_size: "60cm",
                    top_plate: "ガラストップ",
                    weight_kg: "48.92",
                    carousel_images: [
                        {
                            id: 1,
                            image_url: "/assets/img/pr_tc/slide01/01.jpeg",
                            sort_order: 1,
                        },
                        {
                            id: 2,
                            image_url: "/assets/img/pr_tc/slide01/02.jpeg",
                            sort_order: 2,
                        },
                        {
                            id: 3,
                            image_url: "/assets/img/pr_tc/slide01/03.jpeg",
                            sort_order: 3,
                        },
                    ],
                },
                {
                    carousel_images: [
                        // {
                        //     id: 1,
                        //     image_url: "/assets/img/pr_tc/slide01/01.jpeg",
                        //     sort_order: 1,
                        // },
                        // {
                        //     id: 2,
                        //     image_url: "/assets/img/pr_tc/slide01/02.jpeg",
                        //     sort_order: 2,
                        // },
                        // {
                        //     id: 3,
                        //     image_url: "/assets/img/pr_tc/slide01/03.jpeg",
                        //     sort_order: 3,
                        // },
                    ],
                    color: null,
                    comment: "8/26にテスト登録した商品です",
                    discount_rate: 0,
                    display_end_at: "2025-08-31T14:59:00.000000Z",
                    display_sort_order: 1,
                    display_start_at: "2025-08-01T15:00:00.000000Z",
                    eyecatch_image_url: "/assets/img/pr_tc/push_01.png",
                    grill_depth_mm: null,
                    grill_height_mm: null,
                    grill_width_mm: null,
                    heating_capacity: null,
                    id: "0198e037-57f9-7090-8ed1-7d9e69bcdba4",
                    inventory: 10,
                    is_active: true,
                    is_limited: false,
                    is_low_stock: true,
                    is_outlet: false,
                    is_recommended: true,
                    manufacturer: "パロマ",
                    model: "PA-S46H",
                    model_salesforce: "PA-S46H",
                    name: "下舞テストテーブルコンロ1",
                    output_kw: null,
                    power_source: null,
                    product_type: "stove",
                    recommended_body: null,
                    recommended_headline: null,
                    recommended_sort_order: null,
                    sales_price: 19800,
                    size_depth_mm: null,
                    size_height_mm: null,
                    size_width_mm: null,
                    standard_price: null,
                    top_board_size: null,
                    top_plate: null,
                    weight_kg: null,
                },
            ];
            console.log(`Fetching skipped for ${hostname}, using defaultData.`);
            return defaultData;
        } else {
            const defaultData: ProductsResponse[] = [
                {
                    color: "エレガントホワイト",
                    comment:
                        "省エネ性能に優れたおすすめのガスファンヒーターです。",
                    discount_rate: 11,
                    display_end_at: "2025-09-24T02:51:19.000000Z",
                    display_sort_order: 0,
                    display_start_at: "2025-08-24T02:51:19.000000Z",
                    eyecatch_image_url: "assets/img/pr_fh/sfg-409r.jpg",
                    grill_depth_mm: 355,
                    grill_height_mm: 120,
                    grill_width_mm: 321,
                    heating_capacity: "small",
                    id: "0198df23-25da-70da-90f7-00356bef0690",
                    inventory: 8,
                    is_active: true,
                    is_limited: true,
                    is_low_stock: false,
                    is_outlet: true,
                    is_recommended: true,
                    manufacturer: "株式会社サイブガス",
                    model: "HEATER-RECOMMEND",
                    model_salesforce: "SF-HEATER-RECOMMEND",
                    name: "おすすめガスファンヒーター",
                    output_kw: "4.5",
                    power_source: "都市ガス",
                    product_type: "heater",
                    recommended_body:
                        "環境に優しく経済的な暖房器具です。快適な室温を効率よく保ちます。",
                    recommended_headline: "省エネ性能抜群のヒーター",
                    recommended_sort_order: 44,
                    sales_price: 26660,
                    size_depth_mm: 175,
                    size_height_mm: 485,
                    size_width_mm: 455,
                    standard_price: 38320,
                    top_board_size: "60cm",
                    top_plate: "ガラストップ",
                    weight_kg: "14.20",
                    carousel_images: [
                        {
                            id: 1,
                            image_url: "assets/img/pr_fh/point01_img.jpg",
                            sort_order: 1,
                        },
                        {
                            id: 2,
                            image_url: "assets/img/pr_fh/point02_img.jpg",
                            sort_order: 2,
                        },
                    ],
                },
                {
                    color: "ベージュ",
                    comment:
                        "効率的な暖房効果を持つガスファンヒーターです。省エネ設計の商品1です。",
                    discount_rate: 88,
                    display_end_at: "2025-09-24T02:51:19.000000Z",
                    display_sort_order: 1,
                    display_start_at: "2025-08-24T02:51:19.000000Z",
                    eyecatch_image_url: "assets/img/pr_fh/sgf-423dxcr-rm.jpg",
                    grill_depth_mm: 341,
                    grill_height_mm: 111,
                    grill_width_mm: 266,
                    heating_capacity: "medium",
                    id: "0198df23-2591-7255-a4f3-58aaf6db84ab",
                    inventory: 3,
                    is_active: true,
                    is_limited: false,
                    is_low_stock: false,
                    is_outlet: false,
                    is_recommended: true,
                    manufacturer: "株式会社サイブガス",
                    model: "HEATER-1",
                    model_salesforce: "SF-HEATER-1",
                    name: "ガスファンヒーター商品1",
                    output_kw: "3.5",
                    power_source: "電気",
                    product_type: "heater",
                    recommended_body:
                        "Quia quod eligendi praesentium praesentium rerum. Et amet impedit ipsum sed aut a voluptatem.",
                    recommended_headline: "Tenetur harum nihil a est et.",
                    recommended_sort_order: 6,
                    sales_price: 9107,
                    size_depth_mm: 160,
                    size_height_mm: 460,
                    size_width_mm: 440,
                    standard_price: 19853,
                    top_board_size: "90cm",
                    top_plate: "フッ素コートトップ",
                    weight_kg: "12.50",
                    carousel_images: [
                        {
                            id: 1,
                            image_url: "assets/img/pr_fh/point01_img.jpg",
                            sort_order: 1,
                        },
                        {
                            id: 2,
                            image_url: "assets/img/pr_fh/point02_img.jpg",
                            sort_order: 2,
                        },
                        {
                            id: 3,
                            image_url: "assets/img/pr_fh/point02_img.jpg",
                            sort_order: 3,
                        },
                        {
                            id: 4,
                            image_url: "assets/img/pr_fh/point02_img.jpg",
                            sort_order: 3,
                        },
                    ],
                },
                {
                    color: "ベージュ",
                    comment:
                        "効率的な暖房効果を持つガスファンヒーターです。省エネ設計の商品1です。",
                    discount_rate: 1,
                    display_end_at: "2025-09-24T02:51:19.000000Z",
                    display_sort_order: 1,
                    display_start_at: "2025-08-24T02:51:19.000000Z",
                    eyecatch_image_url: "assets/img/pr_fh/sgf-423dxcr-rm.jpg",
                    grill_depth_mm: 341,
                    grill_height_mm: 111,
                    grill_width_mm: 266,
                    heating_capacity: "large",
                    id: "0198df23-2591-7255-a4f3-58aaf6db84bc",
                    inventory: 10,
                    is_active: true,
                    is_limited: true,
                    is_low_stock: true,
                    is_outlet: false,
                    is_recommended: true,
                    manufacturer: "株式会社サイブガス",
                    model: "HEATER-1",
                    model_salesforce: "SF-HEATER-1",
                    name: "ガスファンヒーター商品1",
                    output_kw: "3.5",
                    power_source: "電気",
                    product_type: "heater",
                    recommended_body:
                        "Quia quod eligendi praesentium praesentium rerum. Et amet impedit ipsum sed aut a voluptatem.",
                    recommended_headline: "Tenetur harum nihil a est et.",
                    recommended_sort_order: 6,
                    sales_price: 9107,
                    size_depth_mm: 160,
                    size_height_mm: 460,
                    size_width_mm: 440,
                    standard_price: 10000,
                    top_board_size: "90cm",
                    top_plate: "フッ素コートトップ",
                    weight_kg: "12.50",
                    carousel_images: [],
                },
            ];

            console.log(`Fetching skipped for ${hostname}, using defaultData.`);
            return defaultData;
        }
    }
};

export const getSummary = async (
    product_type: "stove" | "heater"
): Promise<SummaryResponse | null> => {
    if (API_AVAILABLE) {
        try {
            const response = (await axios.get(
                `${baseURL}/api/products/summary?product_type=${product_type}`,
                {
                    withCredentials: false,
                    headers: {
                        Accept: "application/json",
                    },
                }
            )) as { data: SummaryResponse };
            // console.log("getSummaryResponse:", response);
            const data = response.data;
            return data;
        } catch (error) {
            console.error("getSummaryError:", error);
            return null;
        }
    } else {
        // stg.saibuland.com 以外のドメインでは、ダミーデータを返す
        if (product_type === "stove") {
            const defaultData: SummaryResponse = {
                max_discount_rate: 27,
                has_outlet_products: true,
            };
            console.log(`Fetching skipped for ${hostname}, using defaultData.`);
            return defaultData;
        } else {
            const defaultData: SummaryResponse = {
                max_discount_rate: 10,
                has_outlet_products: true,
            };
            console.log(`Fetching skipped for ${hostname}, using defaultData.`);
            return defaultData;
        }
    }
};

export const postOrder = async (
    payload: OrdersRequest,
    navigate?: (path: string) => void
): Promise<OrdersResponse | null> => {
    if (API_AVAILABLE) {
        try {
            const response = (await axios.post("/api/orders", payload, {
                withCredentials: false,
                headers: {
                    Accept: "application/json",
                },
                timeout: 10000, // 10秒
            })) as { data: OrdersResponse };
            const data = response.data;
            return data;
        } catch (error: unknown) {
            console.error("postOrderError:", error);

            // AxiosErrorかどうかをチェック
            if (error instanceof AxiosError && error.response) {
                if (error.code === "ECONNABORTED") {
                    console.error(
                        "タイムアウトエラーを捕捉 → タイムアウトエラーページにリダイレクト"
                    );
                    navigate?.("/error_timeout");
                    return null;
                }

                const status = error.response.status;

                if (status >= 500 && status < 600) {
                    console.log(
                        "500エラーを捕捉 → システムエラーページにリダイレクト"
                    );
                    navigate?.("/error_system");
                    return null;
                }

                // 在庫切れエラーの判定ロジック
                const errorResponse = error.response.data?.messages;
                if (errorResponse && typeof errorResponse === "object") {
                    const allMessages = Object.values(errorResponse).flat();
                    const hasStockError = allMessages.some(
                        (msg: unknown) =>
                            typeof msg === "string" &&
                            msg.includes("在庫が不足")
                    );
                    if (hasStockError) {
                        console.log(
                            "在庫切れエラーを捕捉 → 在庫エラーページにリダイレクト"
                        );
                        localStorage.removeItem("localProductId");
                        navigate?.("/error_stock");
                        return null;
                    }
                }
            }
            return null;
        }
    } else {
        // ====== モックレスポンス（15秒遅延） ======
        console.log("テスト: モックAPIを設定します");

        // mock.onPost("/api/orders").reply(() => {
        //     return new Promise((resolve, reject) => {
        //         // 10秒で強制エラー
        //         const timeoutId = setTimeout(() => {
        //             reject(new AxiosError("timeout", "ECONNABORTED"));
        //         }, 10000); //タイムアウト秒

        //         // 15秒後に通常レスポンス
        //         setTimeout(() => {
        //             clearTimeout(timeoutId);
        //             resolve([
        //                 500, //エラーステータス
        //                 {
        //                     success: true,
        //                     order_id: "mock-123",
        //                     order_token: "mock-token-abc",
        //                     order_token_expire_at:
        //                         "2025-08-28T00:00:00.000000Z",
        //                 },
        //             ]);
        //         }, 100); //実際のレスポンスまでの秒数ミリ秒
        //     });
        // });

        // try {
        //     const response = (await axios.post("/api/orders", payload, {
        //         timeout: 10000, // 10秒でタイムアウト
        //     })) as {
        //         data: OrdersResponse;
        //     };
        //     console.log("モック postOrderResponse:", response);
        //     return response.data;
        // } catch (error) {
        //     console.error("モック postOrderError:", error);

        //     if (axios.isAxiosError(error) && error.response?.status === 500) {
        //         console.log(
        //             "500エラーを捕捉 → システムエラーページにリダイレクト"
        //         );
        //         navigate?.("/error_system");
        //     }

        //     // // タイムアウトエラー判定
        //     // if (axios.isAxiosError(error) && error.code === "ECONNABORTED") {
        //     //     console.error("リクエストがタイムアウトしました");
        //     //     navigate?.("/error_timeout");
        //     //     return null;
        //     // }
        //     return null;
        // }


        const defaultData: OrdersResponse = {
            success: true,
            order_id: "123-890",
            order_token: "1234567890",
            order_token_expire_at: "2025-08-28T00:00:00.000000Z",
        };
        // const defaultData: OrdersResponse = {
        //
        //
        //     message: "1234567890",
        //    errors: [{},{}],
        // };
        console.log(`Fetching skipped for ${hostname}, using defaultData.`);
        return defaultData;
    }
};
// {
//     "data": {
//         "message": "入力エラーがあります。入力内容をご確認ください。",
//         "messages": {
//             "products.0.quantity": [
//                 "商品「下舞がテストのために登録したスーパー高性能で安いけど安全な寒気知らずのとてもおすすめファンヒーター1」の在庫が不足しています。在庫数: 0, 注文数: 1"
//             ]
//         }
//     },
//     "status": 400,
//     "statusText": "",
//     "headers": {
//         "cache-control": "no-cache, private",
//         "content-type": "application/json",
//         "date": "Thu, 04 Sep 2025 01:44:28 GMT",
//         "referrer-policy": "strict-origin-when-cross-origin",
//         "server": "none",
//         "strict-transport-security": "max-age=31536000; includeSubDomains",
//         "vary": "x-xsrf-token, Origin",
//         "via": "1.1 7b8db22cd1023b4d59f13ca0f81c1ad6.cloudfront.net (CloudFront)",
//         "x-amz-cf-id": "AROOua3UsoXx3lsfrFYWqUXmVFYfeTw5SMA8xLtORbEeVCD8m_vM6w==",
//         "x-amz-cf-pop": "KIX56-P1",
//         "x-cache": "Error from cloudfront",
//         "x-content-type-options": "nosniff",
//         "x-frame-options": "SAMEORIGIN",
//         "x-xss-protection": "1; mode=block"
//     },
//     "config": {
//         "transitional": {
//             "silentJSONParsing": true,
//             "forcedJSONParsing": true,
//             "clarifyTimeoutError": false
//         },
//         "adapter": [
//             "xhr",
//             "http",
//             "fetch"
//         ],
//         "transformRequest": [
//             null
//         ],
//         "transformResponse": [
//             null
//         ],
//         "timeout": 0,
//         "xsrfCookieName": "XSRF-TOKEN",
//         "xsrfHeaderName": "X-XSRF-TOKEN",
//         "maxContentLength": -1,
//         "maxBodyLength": -1,
//         "env": {},
//         "headers": {
//             "Accept": "application/json, text/plain, */*",
//             "Content-Type": "application/json"
//         },
//         "withCredentials": false,
//         "method": "post",
//         "url": "/api/orders",
//         "data": "{\"orderer_given_name\":\"あ\",\"orderer_family_name\":\"あ\",\"orderer_given_kana\":\"ア\",\"orderer_family_kana\":\"ア\",\"orderer_phone\":\"090-3320-3985\",\"orderer_postal_code\":\"812-0041\",\"orderer_pref_code\":\"40\",\"orderer_city\":\"福岡市博多区吉塚\",\"orderer_address1\":\"11\",\"ship_family_name\":\"あ\",\"ship_given_name\":\"あ\",\"ship_family_kana\":\"ア\",\"ship_given_kana\":\"ア\",\"ship_phone\":\"090-3320-3985\",\"ship_postal_code\":\"812-0041\",\"ship_pref_code\":\"40\",\"ship_city\":\"福岡市博多区吉塚\",\"ship_address1\":\"11\",\"products\":[{\"product_id\":\"0198e144-0736-714d-8c77-769fff2d458f\",\"quantity\":1}],\"payment_method\":\"CREDITCARD_WAP\"}",
//         "allowAbsoluteUrls": true
//     },
//     "request": {}
// }
